import { ErrorPage } from './ErrorPage';

export const NotFoundPage = () => {
    return (
        <ErrorPage code={404} errorText='Такой страницы не существует!' />
    );
}